import {Component, OnInit} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-been-here-icon',
    templateUrl: './been-here-icon.component.html',
    styleUrls: ['./been-here-icon.component.scss']
})
export class BeenHereIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 16;
    }
}
